import IconBus from "@Icons/transportType/IconBus";
import IconFerry from "@Icons/transportType/IconFerry";
import IconPlane from "@Icons/transportType/IconPlane";
import IconTrain from "@Icons/transportType/IconTrain";
import IconTransfer from "@Icons/transportType/IconTransfer";

export const Transportation = ({transportType, width = 20, height = 20}: { transportType: number, width?: number | string, height?: number | string }) => {
    if (transportType == 1) {
        return (
            <IconBus width={width} height={height}/>
        );
    }

    if (transportType == 2) {
        return (
            <IconFerry width={width} height={height}/>
        );
    }

    if (transportType == 3) {
        return (
            <IconTrain width={width} height={height}/>
        );
    }

    if (transportType == 4) {
        return (
            <IconPlane width={width} height={height}/>
        );
    }

    if (transportType == 5) {
        return (
            <IconTransfer width={width} height={height}/>
        );
    }
}